import { render, staticRenderFns } from "./philosophies-details.vue?vue&type=template&id=4ee342d8&"
import script from "./philosophies-details.vue?vue&type=script&lang=js&"
export * from "./philosophies-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports